<template>
  <div class="h-dialogContainer">
    <form id='delRange'>
      <div class='row h-row-inputBox'>
        <div class="col-sm-6 h-col-inputBox">
          <div class='h-inputLit'>{{title}}:</div>
        </div>
      </div>
      <div class='row h-row-inputBox'>
        <div class="col-sm-5 h-col-inputBox">
          <ejs-textbox name='startImsi' :placeholder='$t("LteUser.character15")' v-model="param.startImsi"></ejs-textbox>
        </div>
        <span class="col-sm-1 h-col-inputBox">~</span>
        <div class="col-sm-5 h-col-inputBox">
          <ejs-textbox name='endImsi' :placeholder='$t("LteUser.character15")' v-model="param.endImsi"></ejs-textbox>
        </div>
      </div>
    </form>
    <Notification ref='notification' :position='position' timeOut='2000' ></Notification>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import ajaxUrl from "../../../data/ajaxUrl";
import Notification from "../../../util/tipDialog/Notification";
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: "DelRangeUserForm",
  components: {
    Notification,
  },
  methods: {
    getDatas() {
      if (this.validate()) {
        return this.param;
      }
      return;
    },
    bindValidate() {
      this.formObj = new FormValidator('#delRange', this.validationOption);
    },
    validate() {
      return this.formObj.validate();
    },
    delRangeUser(ne, callback) {
      const formData = this.getDatas();
      if (formData) {
        const count = Number(this.param.endImsi) - Number(this.param.startImsi) + 1;
        if (count <= 0) {
          this.$loading.hideLoadding();
          EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.atleastone")});
          //this.$refs.notification.error({ title: this.$t("LteUser.wrong"), content: this.$t("LteUser.atleastone") });
          return;
        }
        if (count > 10000) {
          this.$loading.hideLoadding();
          //this.$refs.notification.error({ title:this.$t("LteUser.wrong"), content: this.$t("LteUser.atmost") });
          EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.atmost")});
          return;
        }
        const delUserList = [];
        for (let i=0; i<count; i++) {
          delUserList.push({
            imsi: (Number(formData.startImsi) + i).toString(),
          })
        }
        const params = {
          vo: {
            imsi: formData.startImsi,
            count: count,
            bitmask: 1,
          },
          info: {
            msgid: "17063",
            neid: ne.neid,
          },
          log: {
            module: 'res.subscriber#res.subscriber_lte#res.subscriber_lte_user',
            execFunName: 'subscriber.delUser',
            exectype: 1,
            execData: delUserList
          }
        };
        this.$axios.post(ajaxUrl.delRangeUser, params).then(response => {
          if (callback) {
            callback(response, delUserList);
          }
        });
      }
    }
  },
  data() {
    return {
      ne: null,
      opCode: "add",
      msgId: "17066",
      timer1: null,
      title: this.$t("LteUser.imsiRange"),
      position: { X: 'Center', Y: 'Top' },
      formObj: null,
      validationOption: {
        customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          startImsi: {
              required: [true, this.$t("PDN.required")],
              regex: ['^\\d*$',this.$t("LteUser.invalidnum")],
              regex: ['^[1-9]\\d*$',this.$t("LteUser.imsireg")],
              minLength: [15, this.$t("LteUser.length15")],
              maxLength: [15, this.$t("LteUser.length15")],
          },
          endImsi: {
              required: [true, this.$t("PDN.required")],
              regex: ['^\\d*$', this.$t("LteUser.invalidnum")],
              regex: ['^[1-9]\\d*$',this.$t("LteUser.imsireg")],
              minLength: [15, this.$t("LteUser.length15")],
              maxLength: [15, this.$t("LteUser.length15")],
          },
        }
      },
      param: {
        startImsi: '',
        endImsi: ''
      },
    };
  },
  mounted() {
    this.timer1 = setTimeout(() => {
      this.bindValidate();
    }, 200);
  },
  beforeDestroy() {
    if (this.timer1) {
      clearTimeout(this.timer1);
      this.timer1 = null;
    }
  }
};
</script>
